import styled, { css } from 'styled-components';
import { Flex, Heading, isMobileStyleMixin, Link, Tag } from '@amzn/storm-ui';
import { PAGE_LAYOUT_TYPE } from 'src/app/slice';

export const HeaderWrapper = styled(Flex)<{
  pageLayoutType: PAGE_LAYOUT_TYPE;
}>`
  ${(props) =>
    props.pageLayoutType === PAGE_LAYOUT_TYPE.FOCUS
      ? `width: 100%; left: 0;`
      : `min-height: 60px;`}
  box-sizing: border-box;
  background-color: ${({ theme, pageLayoutType }) =>
    theme.header.contextBar[pageLayoutType]?.backgroundColor ||
    theme.header.contextBar[PAGE_LAYOUT_TYPE.STANDARD].backgroundColor};
  color: ${({ theme, pageLayoutType }) =>
    theme.header.contextBar[pageLayoutType]?.textColor ||
    theme.header.contextBar[PAGE_LAYOUT_TYPE.STANDARD].textColor};
  ${isMobileStyleMixin(css`
    padding: 0;
    height: auto;
  `)};
  width: 100%;
`;

export const Topbar = styled.header<{ isWrapped: boolean }>`
  width: 100%;
  display: flex;
  flex-grow: 1;
  align-items: center;
  ${isMobileStyleMixin(css`
    min-height: 60px;
  `)};

  ${({ isWrapped }) =>
    isWrapped &&
    css`
      padding-top: ${({ theme }) => theme.spacing.small.default};
    `};
`;

export const TopbarSecondRow = styled.header`
  display: flex;
  width: 100%;
  align-items: center;
  margin-inline-start: ${({ theme }) => theme.spacing.xsmall.default};
  padding: ${({ theme }) =>
    `${theme.spacing.small.default} ${theme.spacing.base.default}`};
`;

export const UserDropdownWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.base.default} 0;

  && a {
    color: ${({ theme }) => theme.link.color.default};
  }
`;

export const UserDropdownSectionContainer = styled('div')`
  padding-inline: ${({ theme }) => theme.spacing.base.default};
  min-width: 224px;
  max-width: 400px;
`;

export const SwitchAccountsLink = styled(Link)<{ withMargin: boolean }>`
  display: block;
  ${({ withMargin }) =>
    withMargin &&
    css`
      margin-top: ${({ theme }) => theme.spacing.xxsmall.default};
    `};
`;

export const AlertContainer = styled.div`
  background-color: ${({ theme }) => theme.surface.offset};
  padding: ${({ theme }) =>
    `${theme.spacing.xsmall.default} ${theme.spacing.xxsmall.default}`};
  border-radius: ${({ theme }) => theme.border.radius[100]};
`;

export const DropdownContainer = styled.div`
  position: absolute;
  z-index: 1;

  && div[role='listbox'] {
    position: unset;
  }
`;

export const HeaderLink = styled(Link)<{ inverted?: boolean }>`
  && {
    color: ${({ theme, inverted }) =>
      inverted ? theme.link.color.inverted : theme.link.color.default};
  }
`;

export const StyledHeading = styled(Heading)`
  text-transform: none;
`;

export const StyledThemeModeTag = styled(Tag)`
  margin-inline-start: ${({ theme }) => theme.spacing.xxxsmall.default};
`;
